import * as React from 'react';
export const IcControler = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.38 9.08a1 1 0 00-1.09.21l-2 2a1 1 0 000 1.41l2 2A1 1 0 006 15a.84.84 0 00.38-.08A1 1 0 007 14v-4a1 1 0 00-.62-.92zM10 7h4a1 1 0 00.93-.62 1 1 0 00-.23-1.08l-2-2A1.08 1.08 0 0012 3a1 1 0 00-.7.29l-2 2A1 1 0 0010 7zm4 10h-4a1 1 0 00-.71 1.7l2 2c.191.185.444.292.71.3a1 1 0 00.71-.29l2-2A1 1 0 0014 17zm6.71-5.68l-2-2A1 1 0 0017 10v4a1 1 0 001 1 1 1 0 00.71-.29l2-2A1 1 0 0021 12a1 1 0 00-.3-.68h.01zM12 9a3 3 0 100 6 3 3 0 000-6z'
      fill='currentColor'
    />
  </svg>
);
